const error = {
    sessionExpired: 'Session expired, please login again',
    noPermission: 'No permission to access this resource',
    resourceNotFound: 'Resource not found',
    serverError: 'Internal server error',
    requestFailed: 'Request failed',
    networkError: 'Network timeout or server error',
  }

export default error
